import React, { useEffect, useRef } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import { Box } from "@mui/material";

function GameVideo({ socketData }) {
  const { unityProvider, isLoaded, loadingProgression, sendMessage } = useUnityContext({
    loaderUrl: "/Build/MingleWeb.loader.js",
    dataUrl: "/Build/MingleWeb.data",
    frameworkUrl: "/Build/MingleWeb.framework.js",
    codeUrl: "/Build/MingleWeb.wasm",
  });

  const spunForRoundRef = useRef(null);

  // Debug helper
  useEffect(() => {
    if (isLoaded) {
      window.testSpin = (obj, func, param = "") => {
        console.log(`[TEST] ${obj}.${func}(${param})`);
        sendMessage(obj, func, param);
      };
    }
  }, [isLoaded, sendMessage]);

  // Team List (apne game ke exact teams daal do)
  const teamNameList = [
    "PUNJAB", "RCB", "KKR", "LSG", "MI", "CSK", "RR", "SRH", "DC", "GT"
  ];

  const getTeamIndex = (teamName) => {
    if (!teamName) return -1;
    return teamNameList.findIndex(t => 
      t.toUpperCase() === teamName.toString().toUpperCase()
    );
  };

  const triggerSpinWithWinner = (winnerTeamName) => {
    if (!winnerTeamName) return;

    const index = getTeamIndex(winnerTeamName);
    console.log(`🎰 Triggering spin for: ${winnerTeamName} (Index: ${index})`);

    if (index === -1) {
      console.warn("Team not found in list!");
      return;
    }

    // Existing methods try kar rahe hain
    try {
      // Option 1: Direct variables set karne ki koshish (Unity public fields)
      sendMessage("WheelController", "stopPlayerIndex", index.toString());

      // Option 2: StartSpin ko call with parameter
      setTimeout(() => {
        sendMessage("WheelController", "StartSpin", index.toString());
      }, 150);

    } catch (e) {
      console.error("SendMessage failed", e);
    }
  };

  useEffect(() => {
    if (!isLoaded || !socketData) return;

    const { bettingClosed, roundId, settlement, winner } = socketData;

    const effectiveRoundId = roundId ?? settlement?.id ?? settlement?.roundId;
    const winnerTeam = winner ?? settlement?.winnerTeam ?? settlement?.winner;

    if (
      bettingClosed &&
      winnerTeam &&
      effectiveRoundId &&
      spunForRoundRef.current !== effectiveRoundId
    ) {
      spunForRoundRef.current = effectiveRoundId;
      triggerSpinWithWinner(winnerTeam);
    }
  }, [socketData, isLoaded]);

  return (
    <Box style={{ width: "100%", height: "100%", overflow: "hidden", background: "#000" }}>
      {!isLoaded && (
        <Box style={{ padding: "20px", color: "#fff", textAlign: "center" }}>
          Loading Game... {Math.round(loadingProgression * 100)}%
        </Box>
      )}
      <Unity
        unityProvider={unityProvider}
        style={{ width: "100%", height: "100%", display: "block" }}
      />
    </Box>
  );
}

export default GameVideo;